<template>
    <div class="d-flex featured-ad mb-3" v-if="refDesAd != null">
        <div class="d-flex flex-column justify-content-center align-items-center p-2">
            <img class="featured-ad-mfr-image" v-bind:src="refDesAd.manufacturerLogoUrl" />
            <img class="featured-ad-mfr-image" v-bind:src="partImageSrc(refDesAd.partImageUrl)">
            <a class="font-size-8" target="_blank" v-bind:href="refDesAd.imageCreditUrl" v-if="refDesAd.hasImage == true">{{refDesAd.imageCreditName}}</a>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-start flex-grow-1 p-2">
            <div>{{refDesAd.manufacturerName}}</div>
            <!--
        <router-link class="influenced-ad-link-internal font-size-14" @click="iClick"  rel="nofollow"
                     :to="`/${instance}/reference/mfr/${refDesAd.manufacturerNameClean}/src/${refDesAd.manufacturerPartNumberClean}/p/1`">{{refDesAd.manufacturerPartNumber}}</router-link>-->
            <span>{{refDesAd.manufacturerPartNumber}}</span>
            <div class="font-size-10" v-if="refDesAd.hasAdDetailsText == true">{{refDesAd.adDetailsText}}</div>
            <div class="font-size-14 description-div pt-1">
                {{refDesAd.description}}
            </div>
            <div class="font-size-14 short-description-div pt-1">
                {{refDesAd.shortDescription}}
            </div>
        </div>
        <div class="d-flex flex-column pl-2 pb-2">
            <!-- <div class="d-flex justify-content-end">
                <div class="sponsored d-flex align-items-center justify-content-center pl-2 pr-2 pt-1 pb-1" v-bind:class="refDesAd.advertiserBackgroundColorClass">
                    Sponsored
                </div>
            </div>-->
            <div class="influenced-ad-link-external-list d-flex flex-grow-1 justify-content-center align-items-center p-2">
                <div class="d-flex flex-column justify-content-center align-items-center p-2" v-if="refDesAd.hasExternalLink == true">
                    <a @click="eClick" class="influenced-ad-link-external btn btn-light btn-sm d-flex justify-content-start align-items-center" v-bind:class="refDesAd.advertiserExternalLinkClass">
                        <div v-bind:class="refDesAd.externalPartLinkCssClass"></div>
                        <div class="pl-1 pr-1">{{refDesAd.externalPartLinkText}}</div>
                    </a>
                </div>
                <a class="btn btn-dark btn-sm" v-show="loggedIn == true" v-on:click.prevent="dowload(refDesAd.uniqueId)">Download Now</a>
                <a class="btn btn-dark btn-sm" v-show="loggedIn == false" v-on:click.prevent="signIn()">Sign In to Download</a>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'InfluencedRefDesAd',
        props: {
            refDesAd: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: this.$route.path, options: localOptions });
            },
            dowload: function (uniqueId) {
                this.$store.dispatch('gtmReferenceDownload', { mfrName: this.refDesAd.mfrName, mfrPN: this.refDesAd.mfrPN, cadProduct: 'Eagle' })
                this.$store.dispatch('downloadReference', uniqueId);
            },
            iClick() {
                this.$store.dispatch('gtmInfluenceSearch', { action: 'iClick', eventLabel: this.refDesAd.eventLabel, eventType: this.refDesAd.eventType, mfrName: this.refDesAd.mfrName, mfrPN: this.refDesAd.mfrPN, term: this.refDesAd.term, advertiser: this.refDesAd.advertiser });
            },
            eClick() {
                this.$store.dispatch('gtmInfluenceSearch', { action: 'eClick', eventLabel: this.refDesAd.eventLabel, eventType: this.refDesAd.eventType, mfrName: this.refDesAd.mfrName, mfrPN: this.refDesAd.mfrPN, term: this.refDesAd.term, advertiser: this.refDesAd.advertiser });
                this.$store.dispatch('openUrl', { url: this.refDesAd.externalPartLink });
            },
            partImageSrc(imgSrc) {
                if (imgSrc != undefined && imgSrc != null && imgSrc != '')
                    return imgSrc;
                return require('../../assets/images/placeholders/Image-Unavailable.png');
            }
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            loggedIn: function () {
                return this.oidcIsAuthenticated
            },
        }
    }
</script>

<style scoped>
    @media (min-width: 1300px) {
        .short-description-div{
            display: none;
        }
    }
    @media (max-width: 1299.98px) {
        .description-div {
            display: none;
        }
    }
</style>